import React from "react";
import { useNavigate } from "react-router-dom";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import RetailWinnersGrid from "./views/RetailWinnersGrid";

export default function RetailWinnersWrapper() {
     const navigate = useNavigate();

     return (
          <>
               <MainLeftTitle title="Retail Sales Winners">
                    <CreateButton
                         name="Add Winners"
                         onClick={() =>
                              navigate("/app/retail-sales-winners/add")
                         }
                    />
               </MainLeftTitle>

               <RetailWinnersGrid />
          </>
     );
}
